import {ReactNode} from "react";
import makeStyles from "@mui/styles/makeStyles";
import {Box, Dialog, DialogContent, IconButton} from "@mui/material";
import {Close} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
    content: {
        margin: theme.spacing(1),
        overflowX: "scroll",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    }
}));

interface IHelpDialog {
    children: ReactNode | ReactNode[]
    onClose: () => void
    open: boolean
}
export default function HelpDialog({children, onClose, open}: IHelpDialog) {
    const classes = useStyles();

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <Box display="flex" justifyContent="right">
                <Box>
                    <IconButton onClick={onClose}>
                        <Close />
                    </IconButton>
                </Box>
            </Box>
            <DialogContent className={classes.content}>
                {children}
            </DialogContent>
        </Dialog>
    );
}